import { useNavigation } from '@react-navigation/native';
import { t } from 'i18next';
import moment from 'moment';
import { useMemo } from 'react';
import { TouchableHighlight, View } from 'react-native';
import { SCREEN_NAMES } from '../../../constants';
// import { LocationPinFilledIcon, WalletIcon } from '../../../assets/icons';
import { FaRupeeSign } from 'react-icons/fa';
import { BillRefundStatus } from '../../../central-atoms/bill/enums';
import { BillPaymentStatusMap } from '../../../central-atoms/constants/charging/bill/bill';
import { BillPaymentStatus } from '../../../central-atoms/enums/charging/bill/bill';
import { ChargeTransaction } from '../../../central-atoms/types/charging/charge-txns';
import { COLORS } from '../../../config/colors';
import { LocationPinFilledIcon, WalletIcon } from '../../../icons';
import { NumberFormatText } from '../../../miscellaneous/components/NumberFormatText';
import { StyleHelpers } from '../../../miscellaneous/constants/style-helpers';
import { THEME_COLORS } from '../../../theme/constants/themeColors';
import CText from '../../components/CText';
import { AvailableAppVariants } from '../../../theme/enums';
import { APP_VARIANT } from '../../../config/setting';
import { THEME_STYLES } from '../../../theme/constants/themeStyles';

type Props = {
  chargeTxn: ChargeTransaction | any;
};
export default function ChargeTxnCard(props: Props) {
  const { chargeTxn } = props;

  const navigation: any = useNavigation();

  // console.log('chargeTxn', chargeTxn);

  const iconColFlex = 0.06;

  const paymentStatus = useMemo(() => {
    if (chargeTxn?.bill?.payment_status === BillPaymentStatusMap[BillPaymentStatus.Paid]) {
      if (chargeTxn?.bill?.refund_status === BillRefundStatus.Completed) {
        return {
          textColor: COLORS.greenColor,
          text: t('RefundCompleted')
        };
      }

      if (Number(chargeTxn.energy_delivered) > 0) {
        return {
          textColor: COLORS.greenColor,
          text: t('SuccessfulCharge')
        };
      }
    } else if (chargeTxn?.bill?.payment_status === BillPaymentStatusMap[BillPaymentStatus.PartiallyPaid]) {
      return {
        textColor: COLORS.teal300,
        text: t(chargeTxn?.bill?.payment_status)
      };
    } else if (chargeTxn?.bill?.payment_status === BillPaymentStatusMap[BillPaymentStatus.Pending]) {
      return {
        textColor: COLORS.lightOrange,
        text: t(chargeTxn?.bill?.payment_status)
      };
    } else if (chargeTxn?.bill?.payment_status === BillPaymentStatusMap[BillPaymentStatus.Failed]) {
      return {
        textColor: COLORS.red600,
        text: t(chargeTxn?.bill?.payment_status)
      };
    }

    return {
      textColor: COLORS.greyText,
      text: chargeTxn?.bill?.payment_status ? t(chargeTxn?.bill?.payment_status) : ''
    };
  }, [chargeTxn?.bill?.payment_status]);

  return (
    <TouchableHighlight
      underlayColor={THEME_COLORS.cardUnderlayBgColor}
      activeOpacity={0.8}
      onPress={() => {
        navigation.navigate(
          // SCREEN_NAMES.ChargingSuccessfulScreen as never,
          SCREEN_NAMES.ChargingProcessScreen as never,
          {
            chargeTxnId: chargeTxn.id,
            returnScreen: SCREEN_NAMES.ChargingHistoryScreen
          } as never
        );
      }}
      style={{
        // ...StyleHelpers.themeBorder,
        ...THEME_STYLES.item,
        paddingHorizontal: StyleHelpers.pageSpacing.paddingLeft,
        paddingVertical: StyleHelpers.pageSpacing.paddingLeft - 4,
        marginVertical: 8,
        // backgroundColor: COLORS.whiteColor,
        backgroundColor: THEME_COLORS.bgSecondary,
      }}>
      <>
        <View
          style={{
            ...StyleHelpers.verticallyCenteredRow,
            justifyContent: 'space-between',
            borderBottomColor: COLORS.dividerColor,
            borderBottomWidth: 1,
            paddingBottom: StyleHelpers.pageSpacing.paddingLeft - 4,
            marginBottom: StyleHelpers.pageSpacing.paddingLeft - 4
          }}>
          <CText semiBold size={14} style={{ fontWeight: '500' }}>
            {moment(chargeTxn.created_on).format('MMM DD, YYYY')}
          </CText>
          <View>
            <CText
              medium
              size={12}
              style={{
                textAlign: 'right',
                color: paymentStatus.textColor
              }}>
              {paymentStatus.text}
            </CText>
          </View>
        </View>

        {/* cs name */}
        <View
          style={{
            // ...StyleHelpers.verticallyCenteredRow,
            flexDirection: 'row',
            marginVertical: 5,
          }}>
          <View
            style={{
              flex: iconColFlex,
            }}>
            <LocationPinFilledIcon
              height={16}
              width={16}
              style={{
                marginRight: 10,
                marginTop: 4,
              }}
              // stroke={THEME_COLORS.textColor}
              fill={THEME_COLORS.textColor}
            />
          </View>
          <View
            style={{
              flex: 0.9
            }}>
            <CText size={14}>{chargeTxn?.charge_point.charging_station.name}</CText>
          </View>
        </View>

        {/* bill amount */}
        {(!!chargeTxn.bill?.amount.total || !!chargeTxn.bill?.refund_amount) && (
          <View
            style={{
              ...StyleHelpers.verticallyCenteredRow,
              marginVertical: 5,
            }}>
            <View
              style={{
                flex: iconColFlex,
              }}>
              {
                APP_VARIANT === AvailableAppVariants.TataMotorsLite ?
                  <FaRupeeSign
                    height={16}
                    width={16}
                    style={{
                      marginRight: 10
                    }}
                    stroke={THEME_COLORS.borderColor}
                    color={THEME_COLORS.primaryColor}
                  // fill = {THEME_COLORS.borderColor}
                  />
                  :
                  <WalletIcon
                    height={16}
                    width={16}
                    style={{
                      marginRight: 10
                    }}
                  />
              }
            </View>
            <View
              style={{
                flex: 0.9
              }}>
              <CText size={14}>
                <NumberFormatText
                  displayType={'text'}
                  prefix={'₹'}
                  decimalScale={2}
                  // value={Number(activeChargeTransaction?.bill?.amount?.total).toFixed(2)}
                  value={chargeTxn.bill?.amount.total || chargeTxn.bill?.refund_amount}
                  thousandSeparator={true}
                  thousandsGroupStyle={'lakh'}
                />
              </CText>
            </View>
          </View>
        )}
      </>
    </TouchableHighlight>
  );
}
